import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

import { BriefingReport, useBriefingBySlugQuery } from "@/features/briefings";
import { usePageHeader } from "@/shared/store/page-header";

export const Route = createFileRoute("/_authenticated/briefings/$slug")({
  component: BriefingReportPage,
});

function BriefingReportPage() {
  const { slug } = Route.useParams();
  const { data: briefing, isLoading, error } = useBriefingBySlugQuery(slug);
  const { setTitle, reset } = usePageHeader();

  useEffect(() => {
    if (briefing) setTitle(briefing.title);
    return () => reset();
  }, [briefing, setTitle, reset]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error || !briefing) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <p className="text-sm text-muted-foreground">Briefing not found.</p>
      </div>
    );
  }

  return <BriefingReport briefing={briefing} />;
}
